import { render, staticRenderFns } from "./SaveStatus.vue?vue&type=template&id=65949972&scoped=true"
import script from "./SaveStatus.vue?vue&type=script&lang=js"
export * from "./SaveStatus.vue?vue&type=script&lang=js"
import style0 from "./SaveStatus.vue?vue&type=style&index=0&id=65949972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65949972",
  null
  
)

export default component.exports